<div
	class="modal-container"
	*ngIf="announcementDetail?.isExist && !router.url.includes('comparison')"
>
	<div class="modal-wrapper">
		{{ announcementDetail?.description }}
		<mat-icon (click)="onClose()">cancel</mat-icon>
	</div>
</div>
